// Redux
import {
  isRejected,
  Middleware,
  MiddlewareAPI,
  PayloadAction,
} from '@reduxjs/toolkit';
// Antd
import { message } from 'antd';

// Hooks
import { isErrorSuppressed } from '../../hooks/useMutationWithErrorControl';
// Types
import { ApiResponseError } from '../../types';
// Utils
import { handleErrors } from '../../utils/handleErrors';

interface IActionWithMeta extends PayloadAction<ApiResponseError> {
  meta?: {
    requestId?: string;
  };
}

export const ErrorMiddleware: Middleware =
  (_api: MiddlewareAPI) =>
  (next) =>
  (action: PayloadAction<ApiResponseError>) => {
    if (isRejected(action) && action.payload && action.payload.data) {
      // A supressão é casada pelo requestId da própria request, e não por um flag
      // global: o flag era consumido pela primeira rejeição que aparecesse (podia
      // ser de outra request) e ainda expirava sozinho num timeout, então erros
      // lentos voltavam a exibir o toast global além da mensagem da tela.
      const { requestId } = (action as IActionWithMeta).meta || {};

      if (isErrorSuppressed(requestId)) {
        return next(action);
      }

      const error = action.payload.data;
      const tokenErrorMsg = 'Given token not valid for any token type';
      if (
        typeof error === 'string' ||
        !error.message ||
        !error.message.includes(tokenErrorMsg)
      ) {
        // Show the toast as a side effect from the middleware -- NOT from a
        // reducer. Triggering antd's `message` inside a reducer rendered the
        // toast synchronously mid-dispatch, so a mounted RTK Query hook's
        // selector called store.getState() while the reducer was still running
        // ("You may not call store.getState() while the reducer is executing").
        message.error(handleErrors(error), 4);
      }
    }

    return next(action);
  };
